import { appInfo } from "../common/data";
export default [
  {
    path: "/936993d9-e8db-4864-a36c-7cbc9150eaa5",

    children: [
      {
        path: "baa5b8c3-5d61-413b-9ddf-fc39223e8ff2",
        name: "students-list",
        meta: {
          title: "Students",
          authRequired: true,
          acc: ["v47"],
        },
        component: () => import("../views/students/students-list"),
      },
      {
        path: "6853f110-6d66-4a09-957b-4a99a394f2c9",
        name: "new-student",
        meta: {
          title: "New Students",
          authRequired: true,
          acc: ["v23"],
        },
        component: () => import("../views/students/new-student"),
      },
      {
        path: "6853f110-6d66-4a09-957b-4a19452c9",
        name: "bulk-student",
        meta: {
          title: "Upload Students",
          authRequired: true,
          acc: ["y113782"],
          breadcrumb:{
                route: 'students-list'
            
            },
        },
        component: () => import("../views/students/upload-student"),
      },
      {
        path: "6c4576a3-5d3c-4ab7-aec5-0889daf5f355/:er?",
        name: "view-student",
        meta: {
          title: "View Student",
          authRequired: true,
          // breadcrumb:{
          //       route: 'students-list'
            
          //   },
        },
        component: () => import("../views/students/view"),
      },
      {
        path: "c5070346-0686-4fef-9b24-54d9154e44b5/:er?",
        name: "edit-student",
        meta: {
          title: "Update Student",
          authRequired: true,
          breadcrumb:{
                route: 'students-list'
            
            },
        },
        component: () => import("../views/students/edit-student"),
      },
      {
        path: "c5070346-0686-4fef-9b24-54d9154e44b5/:er?",
        name: "edit-student-number",
        meta: {
          title: `Update ${appInfo == "codsms" ? "Admission No" : 'Matric No'}`,
          authRequired: true,
          breadcrumb:{
                route: 'students-list'
            
            },
        },
        component: () => import("../views/students/edit-student-number.vue"),
      },


      // managing students from arm class

       {
        path: "baa5b8c3-5d61-413b-9ddf-fc39223e8ff2",
        name: "students-list",
        meta: {
          title: "Students",
          authRequired: true,
          acc: ["v47"],
        },
        component: () => import("../views/students/students-list"),
      },
      {
        path: "6853f110-6d66-4a09-957b-4a99f2c9-2c9w32",
        name: "new-student-l",
        meta: {
          title: "New Students",
          authRequired: true,
          acc: ["v23"],
        },
        component: () => import("@/views/level/students/register"),
      },
      {
        path: "6853f110-6d66-4a09-957b-4a19452c9-2c9w32",
        name: "bulk-student-l",
        meta: {
          title: "Upload Students",
          authRequired: true,
          acc: ["y113782"],
          breadcrumb:{
                route: 'students-list'
            
            },
        },
        component: () => import("@/views/level/students/upload"),
      },
    ],
  },
];
